// Expert Insights Mobile Swipe Functionality - Transform-based approach
class ExpertInsights {
  constructor() {
    this.init();
  }

  init() {
    this.setupMobileSwipe();
    this.setupScrollIndicators();
    this.removeExistingArrows();
  }

  setupMobileSwipe() {
    const expertGrids = document.querySelectorAll('.expert-insights__grid');
    
    expertGrids.forEach(grid => {
      // Only apply to mobile
      if (window.innerWidth <= 749) {
        this.addSwipeSupport(grid);
      }
    });

    // Handle resize events
    window.addEventListener('resize', () => {
      expertGrids.forEach(grid => {
        if (window.innerWidth <= 749) {
          this.addSwipeSupport(grid);
        } else {
          this.removeSwipeSupport(grid);
        }
      });
    });
  }

  addSwipeSupport(grid) {
    if (grid.dataset.swipeEnabled) return;
    
    grid.dataset.swipeEnabled = 'true';
    
    const cards = grid.querySelectorAll('.expert-card');
    const totalCards = cards.length;
    let currentIndex = 0;
    let startX = 0;
    let startY = 0;
    let isDragging = false;

    // Smooth scroll to specific card
    const scrollToCard = (index) => {
      if (index < 0 || index >= totalCards) return;
      
      const cardWidth = window.innerWidth;
      const scrollPosition = index * cardWidth;
      
      grid.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
      
      currentIndex = index;
      console.log('Scrolling to card:', index, 'Position:', scrollPosition);
    };

    // NO TOUCH EVENTS - Let CSS scroll-snap handle everything naturally
    // This ensures vertical scroll works perfectly without any interference

    // Mouse events for desktop testing
    grid.addEventListener('mousedown', (e) => {
      startX = e.pageX;
      isDragging = true;
      grid.style.cursor = 'grabbing';
    });

    grid.addEventListener('mouseup', (e) => {
      if (isDragging) {
        const endX = e.pageX;
        const diff = startX - endX;

        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            // Drag left - next card
            if (currentIndex < totalCards - 1) {
              scrollToCard(currentIndex + 1);
            }
          } else {
            // Drag right - previous card
            if (currentIndex > 0) {
              scrollToCard(currentIndex - 1);
            }
          }
        }
        isDragging = false;
      }
      grid.style.cursor = 'grab';
    });

    grid.addEventListener('mouseleave', () => {
      grid.style.cursor = 'grab';
      isDragging = false;
    });

    // Add grab cursor
    grid.style.cursor = 'grab';
    
    // Initialize position
    scrollToCard(0);
  }

  // Transform-based methods for smooth scrolling
  snapToNextCard(grid, cards, cardWidth) {
    // This method is now handled by the transform-based approach
    // Keeping for compatibility with scroll indicators
  }

  snapToPreviousCard(grid, cards, cardWidth) {
    // This method is now handled by the transform-based approach
    // Keeping for compatibility with scroll indicators
  }

  snapToCurrentCard(grid, cards, cardWidth) {
    // This method is now handled by the transform-based approach
    // Keeping for compatibility with scroll indicators
  }

  removeSwipeSupport(grid) {
    if (!grid.dataset.swipeEnabled) return;
    
    grid.dataset.swipeEnabled = 'false';
    grid.style.cursor = 'default';
    
    // Remove event listeners by cloning the element
    const newGrid = grid.cloneNode(true);
    grid.parentNode.replaceChild(newGrid, grid);
  }

  setupScrollIndicators() {
    // Navigation arrows disabled - no scroll indicators needed
    // Users can swipe naturally without visual indicators
  }

  addScrollIndicators(grid) {
    // Navigation arrows disabled - function disabled
    return;
  }

  removeExistingArrows() {
    // Remove any existing navigation arrows from the DOM
    const expertGrids = document.querySelectorAll('.expert-insights__grid');
    expertGrids.forEach(grid => {
      const existingIndicators = grid.querySelector('.scroll-indicators');
      if (existingIndicators) {
        existingIndicators.remove();
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ExpertInsights();
});

// Re-initialize for dynamic content (Shopify theme editor)
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', () => {
    new ExpertInsights();
  });
}

